<template>
  <router-link
    class="link"
    :to="{ name: params.path_name, params: params.params_path }"
  >
    <i :class="['fa-solid', params.icon]"></i>
    <span class="space-icon"></span>
    {{ params.text }}
  </router-link>
</template>

<script>
export default {
  name: "GoToLink"
};
</script>
